
import {Vue, Component, Prop, toNative} from 'vue-facing-decorator';
import EmailCategoriesModel from '@/entities/Invite/EmailCategoriesModel';
import InviteEmailTypeEnum from '@/enums/InviteEmailTypeEnum';
import { Root } from '@/main';
import { EmailCategoriesImages } from '@/entities/Invite/EmailCategoriesImages';
@Component
class SideBarListings extends Vue {
  @Prop({default: ''}) readonly activeTab!: string;
  @Prop() emailType!: number;
  @Prop() emailCategoryListing!: EmailCategoriesModel[];

  // Variable storing active & Inactive image icons
  private images: EmailCategoriesImages = new EmailCategoriesImages();

  // Emit selected email Type data to the parent for preview of the template
  private SendSelectedEmailData(email: EmailCategoriesModel) {
    Root.emit('template-selected', email);
  }

  // return active or inactive image for different email types
  private GetImageSrc(isActive: boolean,emailType: string ) {
    let id = 0;
    if(emailType === InviteEmailTypeEnum.InvitationTickets || emailType === InviteEmailTypeEnum.Invitation){
      id = 0;
    }else if(emailType === InviteEmailTypeEnum.ReminderTickets || emailType === InviteEmailTypeEnum.Reminder){
      id = 1;
    }else if(emailType === InviteEmailTypeEnum.Confirmation){
      id = 2;
    } else if(emailType === InviteEmailTypeEnum.ConfirmationTicketsSelfBuy || emailType === InviteEmailTypeEnum.ConfirmationTicketsOthersBuy){
      id = 3;
    } else if (emailType === InviteEmailTypeEnum.ConfirmationTickets){
      id = 2;
    } else if (emailType === InviteEmailTypeEnum.ReminderCompleteRegistration){
      id = 1;
    }else if(emailType === InviteEmailTypeEnum.ResendTickets){
      id = 5;
    } else if(emailType === InviteEmailTypeEnum.Custom){
      id = 6;
    } else{
      id = 4;
    }
    return isActive ? this.images.EmailCategoriesImage[id].ActiveImageSrc : this.images.EmailCategoriesImage[id].ImageSrc;
  }

  // Get Label for each Email Type
  private GetEmailCategoryLabel(type: number){
    switch(type){
    case 0:
      return this.$t('Invite.EmailForFreeEvents').toString();
    case 1:
      return this.$t('Invite.EmailForTicketedEvents').toString();
    case 2:
      return this.$t('Invite.OtherEvents').toString();
    default:
      return '';
    }
  }

  // Assign tooltip content based on different email Types
  private GetTitlesForTooltip(emailType: string){
    switch(emailType){
    case InviteEmailTypeEnum.Invitation:
      return this.$t('Invite.ConfigureEmails.InvitationToolTip').toString();
      break;
    case InviteEmailTypeEnum.Reminder:
      return this.$t('Invite.ConfigureEmails.ReminderToolTip').toString();
      break;
    case InviteEmailTypeEnum.Confirmation:
      return this.$t('Invite.ConfigureEmails.ConfirmationToolTip').toString();
      break;
    case InviteEmailTypeEnum.InvitationTickets:
      return this.$t('Invite.ConfigureEmails.InvitationTicketsToolTip').toString();
      break;
    case InviteEmailTypeEnum.ReminderTickets:
      return this.$t('Invite.ConfigureEmails.ReminderTicketsToolTip').toString();
      break;
    case InviteEmailTypeEnum.ConfirmationTicketsSelfBuy:
      return this.$t('Invite.ConfigureEmails.ConfirmationTicketsToolTip').toString();
      break;
    case InviteEmailTypeEnum.ConfirmationTicketsOthersBuy:
      return this.$t('Invite.ConfigureEmails.ConfirmationTicketsToolTip').toString();
      break;
    case InviteEmailTypeEnum.ReminderCompleteRegistration:
      return this.$t('Invite.ConfigureEmails.CompleteRegistrationToolTip').toString();
      break;
    case InviteEmailTypeEnum.ConfirmationTickets:
      return this.$t('Invite.ConfigureEmails.RegistrationCompletionToolTip').toString();
      break;
    case InviteEmailTypeEnum.AssignTickets:
      return this.$t('Invite.ConfigureEmails.TicketConfirmationToolTip').toString();
      break;
    case InviteEmailTypeEnum.ResendTickets:
      return this.$t('Invite.ConfigureEmails.ResendTicketsToolTip').toString();
      break;
    case InviteEmailTypeEnum.Custom:
      return this.$t('Invite.ConfigureEmails.CustomEmailToolTip').toString();
      break;
    default:
      return '';
    }
  }

}
export default toNative(SideBarListings);
